<template>
    <footer class="footer container">

        <div class="top">

            <div class="left-part">

                <p>
                    <strong>Keep in touch</strong> <br>
                    Get notified about our news and when the new update comes out
                </p>

            </div>

            <form class="right-part" @submit.prevent="sendForm" v-if="!isFormSended" id="subscription_form">

                <v-input placeholder="Email"
                         v-model="formData.email"
                >
                </v-input>

                <button class="btn is-bordered" type="submit">
                    <div>
                        <span>Notify me</span>
                    </div>
                </button>

            </form>

            <transition name="fade-left">
                <div class="thanks-block" v-if="isFormSended">

                    <img src="@/assets/images/icons/CheckMark_small.svg" alt="check mark">

                    <p class="text">You’ve subsribed to our <br> notifications. Thank you!</p>

                </div>
            </transition>

        </div>

        <div class="bottom">

            <div class="left-part">
                <p class="copyright">© Copyright, 2020, Excelsior</p>
            </div>

            <div class="right-part">

                <p class="icons-container">

                    <a href="https://www.linkedin.com/company/excelsior-one/" target="_blank">
                        <img src="@/assets/images/icons/linkedin.svg" alt="linkedin icon">
                    </a>
                    <a href="https://www.facebook.com/Excelsior.One" target="_blank">
                        <img src="@/assets/images/icons/facebook.svg" alt="facebook icon">
                    </a>
                    <a href="https://angel.co/company/excelsior-one-broker" target="_blank">
                        <img src="@/assets/images/icons/angel.svg" alt="angel icon">
                    </a>
                    <a href="https://www.crunchbase.com/organization/excelsior-one" target="_blank">
                        <img src="@/assets/images/icons/ChuncheBase.svg" alt="chunchebase icon">
                    </a>
                    <a href="https://medium.com/@excelsior_one" target="_blank">
                        <img src="@/assets/images/icons/medium-share.svg" alt="medium icon">
                    </a>

                </p>

            </div>

        </div>

    </footer>
</template>

<script>
    export default {
        name: "Footer",
        data() {
            return {
                formData: {
                    email: ''
                },
                isFormSended: false
            }
        },
        methods: {
            sendForm() {
                const params = { 
                    subscriber: this.formData,
                    authenticity_token: this.$cookies.get('form_authenticity_token')
                }
                this.$axios.post("/subscribers", params).then(() => { this.isFormSended = true })
            }
        }
    }
</script>

<style>
    .fade-left-enter-active, .fade-left-leave-active {
        transition: .5s;
        opacity: 1;
        transform: translate(0px, 0px);
    }
    .fade-left-enter, .fade-left-leave-to {
        opacity: 0;
        transform: translate(-40px, 0px);
    }
</style>